<template>
  <div>
    <breadcrumb :routerList="[{to:'/salesPromotionList',title:'促销活动管理'},{ title:'查看促销活动'}]" />
    <div class="h-piece" style="margin:20px">
      <!-- 活动信息 -->
      <div class="h-pieceIn2 n-xiao">
        <div class="h-pieceTitle2 " style="margin-left:10px">
          <h1>活动信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine">
            <el-form ref="ruleForms" :model="order" :rules="ruleForm" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item label="活动名称" class="h-elformWrap-2" prop="activityName">
                <el-input v-model="order.activityName" placeholder="请输入活动名称" readonly/>
              </el-form-item>
              <el-form-item label="活动描述" class="h-elformWrap-2">
                <el-input v-model="order.activityDescription" placeholder="请输入活动描述" readonly/>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="order.createUserName" readonly />
              </el-form-item>
              <el-form-item label="销售公司" class="h-elformWrap-2" prop="saleGroupCode">
                <brselect category="xiaoshou_zuzhi"
                          :v="order.saleGroupCode"
                          :showcode="true" v-model="order.saleGroupCode" disabled/>
<!--                <el-input v-model="order.saleGroup" placeholder="请输入销售公司" readonly/>-->
              </el-form-item>
              <el-form-item label="活动开始日期" class="h-elformWrap-2" prop="startTime">
                <el-date-picker
                    :clearable="false"
                    type="datetime"
                    placeholder="选择开始时间"
                    v-model="order.startTime"
                    readonly
                />
              </el-form-item>
              <el-form-item label="活动结束日期" class="h-elformWrap-2" prop="endTime">
                <el-date-picker
                    :clearable="false"
                    type="datetime"
                    placeholder="选择结束时间"
                    v-model="order.endTime"
                    readonly
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <!-- 产品信息 -->
      <div class="h-pieceIn2 n-xiao">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>产品信息</h1>
        </div>

        <!-- 产品列表 -->
        <div v-if="productData.length > 0">
          <div v-for="(product, productIndex) in productData" :key="productIndex" class="product-item" style="margin-bottom: 10px;">
            <!-- 产品信息表格 -->
            <el-table :data="[product]" stripe border style="width: 70%">
              <el-table-column prop="productCode" label="产品编码" :show-overflow-tooltip="true" width="100"></el-table-column>
              <el-table-column prop="productName" :show-overflow-tooltip="true" label="产品名称" min-width="120"></el-table-column>
<!--              <el-table-column prop="specificationModal" :show-overflow-tooltip="true" label="规格型号" min-width="120"> </el-table-column>-->
              <el-table-column prop="quantity" :show-overflow-tooltip="true" label="数量" width="90"></el-table-column>
<!--              <el-table-column prop="promotionPrice" label="基准价" :show-overflow-tooltip="true" width="90"></el-table-column>-->
            </el-table>

            <!-- 赠品信息表格 -->
            <el-table
                :data="product.giftsList"
                stripe
                border
                style="width: 30%"
            >
              <el-table-column prop="productCode" label="赠品编码" :show-overflow-tooltip="true" width="100"></el-table-column>
              <el-table-column prop="productName" :show-overflow-tooltip="true" label="赠品名称" min-width="120"></el-table-column>
              <el-table-column prop="quantity" :show-overflow-tooltip="true" label="赠品数量" width="90"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="h-txtCenter h-mrt60">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
      </div>
    </div>

  </div>
</template>
<script>
import salesPromotion from "@/api/salesPromotion";
export default {
  data() {
    return {
      // 活动基本信息
      order: {
        activityName: '',        // 活动名称
        startTime: null,         // 开始时间
        endTime: null,           // 结束时间
        activityDescription: '', // 活动描述
        createUser: '',          // 创建人姓名
        createUserCode: '',      // 创建人编码
        saleGroup: '',           // 销售公司
        saleGroupCode: '',       // 销售公司编码
      },
      // 产品数据列表
      productData: [ ],
      ruleForm: {
        activityName: [{required: true, message: '请填写活动名称', trigger: 'blur'}],
        saleGroupCode: [{required: true, message: '请选择销售公司', trigger: 'blur'}],
        startTime: [{required: true, message: '请填写活动开始时间', trigger: 'blur'}],
        endTime: [{required: true, message: '请填写活动结束时间', trigger: 'blur'}],
      },
    };
  },
  methods: {
    getDetail(id) {
      salesPromotion.selectActivityById(id).then(res=>{
        if(res.f){
          this.order= res.obj;
          this.productData = res.obj.productsList
        }
      })
    },
    //返回
    backS(){
      this.$router.go(-1);
    }
  },
  created() {
    let id = this.$route.query.id;
    if(id){
      this.getDetail(id)
    }
  },
  activated() {
    let id = this.$route.query.id;
    if(id){
      this.getDetail(id)
    }
  }
};
</script>
<style scoped>
/* 保持原有样式并补充 */
.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.product-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.no-product {
  border: 1px dashed #ccc;
  border-radius: 4px;
  margin-top: 10px;
}

/* 按钮样式补充 */
::v-deep .el-button--text {
  padding: 0 5px;
}
.h-formbLine .h-elformWrap-2{
  width: 33.3%
}
</style>
